import { observer } from "mobx-react";
import React from "react";
import { getOffshoreData } from "../utils/functions";

const withHomePageLink = (WrappedComponent) => {
  const EnhancedComponent = observer((props) => {
    const { isOffshoreOnly, navigateTo } = getOffshoreData();

    return (
      <WrappedComponent
        {...props}
        navigateTo={navigateTo}
        stateObj={{
          state: isOffshoreOnly ? { from: OFFSHORE } : {},
        }}
      />
    );
  });

  return EnhancedComponent;
};

export default withHomePageLink;
